module.exports = __webpack_public_path__ + "static/media/w_w_hr_45.2f146868.png";